import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

import {
    type UseSetDefaultSiteSectionProps,
    useSetDefaultSiteSection,
} from './useSetDefaultSiteSection';

interface SetSectionAsDefaultButtonProps
    extends UseSetDefaultSiteSectionProps,
        Pick<ButtonProps, 'className' | 'label' | 'size'> {
    siteSection: api.SiteSection;
}

export function SetSectionAsDefaultButton(props: SetSectionAsDefaultButtonProps) {
    const { className, label, size, siteSection } = props;
    const setAsDefault = useSetDefaultSiteSection(props);
    return (
        <Button
            kind="secondary"
            leadingIcon={Icon.Home}
            onPress={() => setAsDefault(siteSection)}
            label={label}
            className={className}
            size={size}
        />
    );
}
